/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencySolana = createReactComponent("outline", "currency-solana", "IconCurrencySolana", [["path", { "d": "M4 18h12l4 -4h-12z", "key": "svg-0" }], ["path", { "d": "M8 14l-4 -4h12l4 4", "key": "svg-1" }], ["path", { "d": "M16 10l4 -4h-12l-4 4", "key": "svg-2" }]]);

export { IconCurrencySolana as default };
//# sourceMappingURL=IconCurrencySolana.mjs.map
